import React, { useState, useEffect, useRef } from "react";
import "../styles/resultpage.css";
import WebCarousel from "./Carousel.jsx";
import ShareBox from "./shareBox.jsx";
import Feedback from "./FeedBack.jsx";
import Button1 from "./button1.jsx";
import Button2 from "./button2.jsx";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import ResultsModal from "./ResultsModal.jsx";
import { incrementSharesAsync } from "./gameSlice.jsx";

function ResultPage() {
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const [modalOpen, setModalOpen] = useState(false);

  const [copySuccess, setCopySuccess] = useState("");

  const [isWiggling, setIsWiggling] = useState(true);

  const lastPlayed = localStorage.getItem("lastPlayed");
  const today = new Date().toDateString();
  useEffect(() => {
    if (lastPlayed !== today) {
      navigate("/"); // Redirect to root if it's a new day
    }

    // Additional cleanup and timeouts here
  }, [navigate]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsWiggling(false);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  function copyToClipboard(e) {
    dispatch(incrementSharesAsync());
    navigator.clipboard.writeText(linkToShare).then(
      () => {
        setCopySuccess("copied!");
        setTimeout(() => setCopySuccess(""), 2000);
      },
      (err) => {
        setCopySuccess("Failed to copy!"); // Handle failure case
      }
    );
  }

  function shareLink() {
    if (navigator.share) {
      navigator
        .share({
          title: "Florida Man",
          text: "Match the Florida Man to his Headline",
          url: linkToShare,
        })
        .then(() => {
          dispatch(incrementSharesAsync());
          // console.log("Thanks for sharing!");
        })
        .catch(console.error);
    } else {
      // Fallback for devices that do not support the Web Share API
      copyToClipboard();
    }
  }

  const linkToShare = "https://florida-man-game.vercel.app/";

  if (lastPlayed === today) {
    return (
      <div className="resultscontainer">
        <div className="topDiv">
          <ShareBox />

          <div className="buttonsRow">
            <div>
              <>
                <Button1
                  className={isWiggling ? "wiggle" : ""}
                  onClick={shareLink}
                >
                  Share
                </Button1>
                {copySuccess ? (
                  <p style={{ color: "#03164a" }}>{copySuccess}</p>
                ) : null}
              </>
            </div>
            <div>
              <Button2 onClick={() => setModalOpen(true)}>Results </Button2>

              <ResultsModal
                isOpen={modalOpen}
                onClose={() => setModalOpen(false)}
              />
            </div>
          </div>
        </div>
        <div className="borderLine"></div>
        <div className="middleDiv">
          <WebCarousel />
        </div>
        <div className="bottomDiv">{/* <Feedback /> */}</div>
      </div>
    );
  }
}

export default ResultPage;
